export default __webpack_public_path__ + "static/media/EXEMPLO 2.3f45e761.jpg";